import React from "react";
import { FieldValues, Path } from "react-hook-form";
import { useFormContext } from "@hawkins/forms";
import { parsePhoneNumber } from "awesome-phonenumber";
import { Input } from "@hawkins/components";

interface PhoneInputFormControlProps<T extends FieldValues> {
  name: Path<T>;
  label: string;
  placeholder: string;
  requirementType?: "required-star" | "optional";
  tabIndex?: number;
  style?: React.CSSProperties;
}

export function PhoneInputFormControl<T extends FieldValues>({
  name,
  label,
  placeholder,
  requirementType,
  tabIndex,
  style,
  ...props
}: PhoneInputFormControlProps<T>) {
  const { watch, setValue } = useFormContext<T>();

  const formatPhoneNumber = (value: string): string => {
    if (!value) return "";

    const phoneNumber = parsePhoneNumber(value);

    return phoneNumber.number?.international || value;
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawInput = e.target.value;

    const inputValue = rawInput.replace(/\s+/g, "").replace(/^(\+?)(.*)/, "+$2");

    setValue(name, inputValue as any, { shouldValidate: true });
  };

  const value = watch(name);

  return (
    <Input
      name={name}
      onChange={handleInputChange}
      value={formatPhoneNumber(value)}
      fullWidth
      label={label}
      placeholder={placeholder}
      requirementType={requirementType}
      tabIndex={tabIndex}
      style={style}
      {...props}
    />
  );
}
